import { useMemo } from "react";
import useAuth from "../../../hooks/useAuth";
import formatProjectTypeName from "../formatProjectTypeName";

export default function useAvailableProjectTypesOptions() {
  const { user } = useAuth();
  const { company } = user;
  const availableProjectTypes = company.availableProjectTypes || [];

  const options = useMemo(() => {
    const projectTypeOptions = availableProjectTypes.map(projectType => [
      projectType,
      formatProjectTypeName(projectType),
    ]);

    return [["", "Global Defaults"], ...projectTypeOptions];
  }, [availableProjectTypes]);

  return options;
}
